module.exports = __webpack_public_path__ + "img/benin.65fab6f9.svg";